import React, { useEffect, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { createRole, updateRole } from "../../../redux/slice/adminRoleSlice";
import { useToast } from "../../../context/TostContext";
import { useLoader } from "../../../context/LoaderContext";
import withModal from "../../../components/withModal";
import CommonButton from "../../../components/commonButton";
import InputField from "../../../components/form/InputField";

const RoleModalInner = ({ onClose, role, onSuccess, isView = false }) => {
  const dispatch = useDispatch();
  const toast = useToast();
  const { setLoading } = useLoader();

  const [name, setName] = useState("");
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    if (role) {
      setName(role.name);
      setIsActive(role.is_active);
    } else {
      setName("");
      setIsActive(true);
    }
  }, [role]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isView) return;
    if (!name.trim()) {
      toast.error("Role name is required");
      return;
    }

    setLoading(true);
    try {
      const action = role
        ? updateRole({ id: role.id, data: { name, is_active: isActive } })
        : createRole({ name });

      const res = await dispatch(action);

      if (res.error) {
        toast.error(res.payload?.message || "Something went wrong");
      } else {
        toast.success(`Role ${role ? "updated" : "created"} successfully`);
        onSuccess();
        onClose();
      }
    } catch (err) {
      toast.error("Failed to save role");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Modal.Body>
        <InputField
          className="mb-3"
          label={{ name: "Role Name" }}
          input={{
            type: "text",
            placeholder: "e.g. Sales Manager",
            value: name,
            onChange: (e) => !isView && setName(e.target.value),
            autoFocus: !isView,
            disabled: isView,
          }}
        />

        {role && (
          <Form.Group className="mb-3">
            <Form.Check
              type="switch"
              id="role-active-switch"
              label="Role Status (Active)"
              checked={isActive}
              onChange={(e) => !isView && setIsActive(e.target.checked)}
              disabled={isView}
            />
          </Form.Group>
        )}

        {!role && !isView && (
          <div className="alert alert-info py-2 small m-0">
            The slug will be automatically generated from the name.
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <CommonButton variant="outline" onClick={onClose} type="button" title={isView ? "Close" : "Cancel"} />
        {!isView && (
          <CommonButton variant="primary" type="submit" title={role ? "Update Role" : "Create Role"} />
        )}
      </Modal.Footer>
    </Form>
  );
};

const RoleModal = withModal(RoleModalInner);

export default RoleModal;
